(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

document.addEventListener('DOMContentLoaded', function (e) {

    var tokenAcceptanceForm = document.getElementById('gdpraccept-tokenacceptance-form');
    function resetMessages() {
        document.querySelectorAll('.field-msg').forEach(function (f) {
            return f.classList.remove('show');
        });
    }
    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    if (tokenAcceptanceForm) {
        var downloadAcceptanceLink = tokenAcceptanceForm.querySelector('.js-form-success a');
        var downloadForm = document.getElementById('gdpraccept-download-form');
        if (downloadForm != null) {
            downloadAcceptanceLink.addEventListener('click', function (e) {
                downloadForm.submit();
            });
        } else {
            downloadAcceptanceLink.remove();
        }
        tokenAcceptanceForm.addEventListener('submit', function (e) {
            e.preventDefault();
            // reset the form messages
            resetMessages();
            // colleact all the data
            var data = {
                email: tokenAcceptanceForm.querySelector('[name=email]').value
            };
            console.log(data);
            // validate the email
            if (!validateEmail(data.email)) {
                tokenAcceptanceForm.querySelector('[data-error=invalidEmail]').classList.add('show');
                return;
            }
            // ajax
            var url = tokenAcceptanceForm.dataset.url;
            var params = new URLSearchParams(new FormData(tokenAcceptanceForm));
            tokenAcceptanceForm.querySelector('.js-form-submission').classList.add('show');
            fetch(url, {
                method: 'POST',
                body: params
            }).then(function (res) {
                return res.json();
            }).catch(function (error) {
                console.log(error);
                resetMessages();
                tokenAcceptanceForm.querySelector('.js-form-undefined-error').classList.add('show');
                throw error;
            }).then(function (response) {
                resetMessages();
                // deal with the responsse
                if (response === 0 || response.status === 'error') {
                    if (response.message) {
                        var span = tokenAcceptanceForm.querySelector('.js-form-error');
                        while (span.firstChild) {
                            span.removeChild(span.firstChild);
                        }
                        var txt = document.createTextNode(response.message);
                        span.appendChild(txt);
                        span.classList.add('show');
                    } else {
                        tokenAcceptanceForm.querySelector('.js-form-undefined-error').classList.add('show');
                    }
                    return;
                }
                tokenAcceptanceForm.querySelector('.js-form-success').classList.add('show');
                // document.getElementById('gdpraccept-download-form').classList.add('show');
                // tokenAcceptanceForm.reset();
            });
        });
    }
});

},{}]},{},[1]);
